export default "__VITE_ASSET__CIoGPsNW__"